import Vue from 'vue'
import SvgIcon from '@/components/common/kvSvgIcon'// svg component
// import svgSprite from '@/components/common/svgSprite'// svg component

// register globally
Vue.component('svg-icon', SvgIcon)
// Vue.component('svg-sprite', svgSprite)

const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
